import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "profile";


moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};

moduleApi.findById = (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id, fields: "id,ho_ten,email,dien_thoai,gioi_tinh,avatar_id" }
    };
    return ApiService(api);
};

moduleApi.update = (dataForm) => {
  let api = {
      module: moduleName,
      type: "partialUpdate",
      value: dataForm
  };
  return ApiService(api);
};


export default moduleApi;
